module.exports = __webpack_public_path__ + "static/media/ewa.e463d270.jpg";